import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const AUTH_TOKEN_UNAVAILABLE = 'auth_token_unavailable';

/** Error returned instead of sending a request when no access token could be acquired. */
export function createAuthTokenError(): FetchBaseQueryError {
  return {
    status: 'CUSTOM_ERROR',
    error: 'Access token unavailable; request was not sent',
    data: { code: AUTH_TOKEN_UNAVAILABLE },
  };
}

export function isAuthTokenUnavailableError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    error.status === 'CUSTOM_ERROR' &&
    'data' in error &&
    typeof error.data === 'object' &&
    error.data !== null &&
    'code' in error.data &&
    error.data.code === AUTH_TOKEN_UNAVAILABLE
  );
}
